window.addEventListener('load', function() {
  document.querySelectorAll('.toggle').forEach(toggleButton => {
    toggleButton.addEventListener('click', e => {
      toggleButton.classList.toggle('active');
    });
  });
  document.querySelectorAll('.channelize-btn ').forEach(channelizeBtn => {
    channelizeBtn.addEventListener('click', e => {
      channelizeBtn.querySelector('button').dispatchEvent(new Event('click'));
    })
  });
});